import { AppShell, Container, Flex, Header, Text } from "@mantine/core";
import { ListingForm } from "./components/ListingForm";
import { WalletConnectButton } from "./components/WalletConnectButton";

function App() {
  return (
    <div className="App">
      <AppShell
        padding="md"
        header={
          <Header height={60} p="xs">
            <Flex justify="space-between">
              <Text size="xl">Ord Auctions Admin</Text>
              <WalletConnectButton />
            </Flex>
          </Header>
        }
        styles={(theme) => ({
          main: {
            backgroundColor:
              theme.colorScheme === "dark"
                ? theme.colors.dark[8]
                : theme.colors.gray[0],
          },
        })}
      >
        <Container w="80%">
          <ListingForm />
        </Container>
      </AppShell>
    </div>
  );
}

export default App;
